import React from 'react';
import { Dialog, DialogContent } from '@mui/material';
import { CustomerEditForm } from './CustomerEditForm';
import { useCreateCustomer } from '../../hooks/useCreateCustomer';
import type { EditableCustomer, EditableCustomerUpdates } from '../../services/customerUpdateApi';
import type { CustomerCreateResult } from '../../services/customerCreateApi';

interface NewCustomerDialogProps {
  open: boolean;
  onClose: () => void;
  onCreated: (result: CustomerCreateResult) => void;
}

const EMPTY_CUSTOMER: EditableCustomer = {
  dataverseCustomerId: '',
  repairShoprCustomerId: '',
  firstName: '',
  lastName: '',
  fullName: '',
  businessName: '',
  designation: '',
  email: '',
  phone: '',
  mobile: '',
  address: '',
  address2: '',
  city: '',
  state: '',
  zip: '',
  notes: '',
  getSms: false,
  optOut: false,
  disabled: false,
  noEmail: false,
  notificationEmail: '',
  invoiceCcEmails: '',
  alias: '',
  domains: '',
  abn: '',
  relationshipTerminationDate: null,
  sendXeroInvoiceOnly: false,
  xeroContactId: '',
  parentCustomerId: null,
};

export const NewCustomerDialog: React.FC<NewCustomerDialogProps> = ({ open, onClose, onCreated }) => {
  const { isSaving, error, submit } = useCreateCustomer();

  const handleSave = async (payload: EditableCustomerUpdates) => {
    const result = await submit(payload);
    onCreated(result);
  };

  return (
    <Dialog open={open} onClose={isSaving ? undefined : onClose} maxWidth="md" fullWidth>
      <DialogContent>
        <CustomerEditForm
          customer={EMPTY_CUSTOMER}
          isSaving={isSaving}
          saveError={error}
          lastSaveResult={null}
          onSave={handleSave}
          onCancel={onClose}
          mode="create"
          title="New Customer"
          submitLabel="Create Customer"
          showIdentity={false}
        />
      </DialogContent>
    </Dialog>
  );
};
